import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../ui/tooltip";

export type DataTableTruncatedTextCellProps = {
  text?: string | null;
  emptyText?: ReactNode;
  className?: string;
  muted?: boolean;
  align?: "left" | "center" | "right";
  tooltip?: boolean;
};

export function DataTableTruncatedTextCell({
  text,
  emptyText = "—",
  className,
  muted = true,
  align = "left",
  tooltip = true,
}: DataTableTruncatedTextCellProps) {
  const value = text?.trim();

  const alignmentClassName =
    align === "right" ? "text-right" : align === "center" ? "text-center" : "text-left";

  if (!value) {
    return (
      <span
        className={cn(
          "block min-w-0",
          muted && "text-muted-foreground",
          alignmentClassName,
          className,
        )}
      >
        {emptyText}
      </span>
    );
  }

  const cell = (
    <span
      tabIndex={tooltip ? 0 : undefined}
      className={cn(
        "block min-w-0 max-w-md cursor-default truncate",
        muted && "text-muted-foreground",
        alignmentClassName,
        className,
      )}
    >
      {value}
    </span>
  );

  if (!tooltip) return cell;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {cell}
      </TooltipTrigger>
      <TooltipContent side='top' className='max-w-sm whitespace-normal break-words'>
        {value}
      </TooltipContent>
    </Tooltip>
  );
}
